import { defineComponent } from "vue";

import "./button.less";

export default defineComponent({
  emits: ["click"],
  props: {
    type: { type: String, default: "default" },
    text: { type: String, default: undefined },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
  },
  setup(props, { slots, emit }) {
    const onClick = (event: MouseEvent) => {
      if (props.disabled || props.loading) return;
      emit("click", event);
    };

    return () => (
      <button
        class={[
          "feiyu-web-share-button",
          `feiyu-web-share-button--type-${props.type}`,
          {
            "feiyu-web-share-button--disabled": props.disabled,
            "feiyu-web-share-button--loading": props.loading,
          },
        ]}
        type="button"
        onClick={onClick}
      >
        <div class="feiyu-web-share-button--content">{slots.default?.() ?? props.text}</div>
      </button>
    );
  },
});
